var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4345 4.7582L12.8928 2.36662M14.2976 1L12.8928 2.36662L14.2976 1ZM7.54763 7.5666C7.9103 7.91473 8.19861 8.3292 8.39595 8.78617C8.59328 9.24313 8.69576 9.73356 8.69746 10.2292C8.69917 10.7249 8.60008 11.2159 8.40589 11.6742C8.21171 12.1324 7.92626 12.5488 7.56599 12.8992C7.20573 13.2497 6.77775 13.5274 6.30672 13.7163C5.83568 13.9052 5.33088 14.0016 4.82139 14C4.3119 13.9983 3.80778 13.8986 3.33805 13.7067C2.86833 13.5147 2.44228 13.2342 2.08443 12.8814C1.38073 12.1726 0.991344 11.2232 1.00015 10.2379C1.00895 9.25247 1.41523 8.30987 2.13149 7.61307C2.84775 6.91627 3.81668 6.52102 4.82958 6.51246C5.84249 6.50389 6.81833 6.8827 7.54693 7.56729L7.54763 7.5666ZM7.54763 7.5666L10.4345 4.7582L7.54763 7.5666ZM10.4345 4.7582L12.5416 6.80813L15 4.41655L12.8928 2.36662L10.4345 4.7582Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.a32e4854b4ddf64cf587c999560f9aa3.svg";
export { ForwardRef as ReactComponent };